(function () {
  const CONFIG = window.FITMENT_CONFIG || {};
  const VEHICLES_JSON_URL = window.FITMENT_VEHICLES_URL;

  let vehicleData = null;
  let selectedVehicle = JSON.parse(localStorage.getItem('fitment_vehicle') || 'null');

  const els = {
    make: document.getElementById('fitment-make'),
    model: document.getElementById('fitment-model'),
    year: document.getElementById('fitment-year'),
    engine: document.getElementById('fitment-engine'),
    search: document.getElementById('fitment-search'),
    clear: document.getElementById('fitment-clear'),
    saved: document.getElementById('fitment-saved'),
    savedLabel: document.getElementById('fitment-saved-label'),
  };

  // ── Bootstrap ──────────────────────────────────────────────
  async function init() {
    try {
      const res = await fetch(VEHICLES_JSON_URL);
      vehicleData = await res.json();
      populateMakes();

      if (selectedVehicle) {
        restoreSelection();
        showSavedVehicle();
      }

      bindEvents();
    } catch (e) {
      console.error('Fitment filter failed to load vehicle data:', e);
    }
  }

  // ── Populate dropdowns ─────────────────────────────────────
  function populateMakes() {
    vehicleData.makes.sort().forEach(make => {
      els.make.add(new Option(make, make));
    });
    els.make.disabled = false;
  }

  function populateModels(make) {
    resetSelect(els.model, 'Select Model');
    resetSelect(els.year, 'Select Year');
    resetSelect(els.engine, 'Select Engine');
    els.year.disabled = true;
    els.engine.disabled = true;

    const models = Object.keys(vehicleData.tree[make] || {}).sort();
    models.forEach(model => els.model.add(new Option(model, model)));
    els.model.disabled = false;
    els.search.disabled = false; // enable from make level
  }

  function populateYears(make, model) {
    resetSelect(els.year, 'Select Year');
    resetSelect(els.engine, 'Select Engine');
    els.engine.disabled = true;

    const years = (vehicleData.tree[make]?.[model]?.years || []).sort().reverse();
    years.forEach(year => els.year.add(new Option(year, year)));
    els.year.disabled = false;
    els.search.disabled = false; // enable from model level
  }

  function populateEngines(make, model, year) {
    resetSelect(els.engine, 'Select Engine');

    const engines = vehicleData.tree[make]?.[model]?.engines?.[year] || [];
    if (engines.length === 0) {
      els.engine.disabled = true;
    } else {
      engines.forEach(eng => els.engine.add(new Option(eng, eng)));
      els.engine.disabled = false;
    }
    els.search.disabled = false; // enable from year level
  }

  // ── Events ─────────────────────────────────────────────────
  function bindEvents() {
    els.make.addEventListener('change', () => {
      if (els.make.value) {
        populateModels(els.make.value);
      } else {
        resetSelect(els.model, 'Select Model');
        resetSelect(els.year, 'Select Year');
        resetSelect(els.engine, 'Select Engine');
        els.model.disabled = true;
        els.year.disabled = true;
        els.engine.disabled = true;
        els.search.disabled = true;
      }
    });

    els.model.addEventListener('change', () => {
      if (els.model.value) populateYears(els.make.value, els.model.value);
    });

    els.year.addEventListener('change', () => {
      if (els.year.value) populateEngines(els.make.value, els.model.value, els.year.value);
    });

    els.engine.addEventListener('change', () => {
      els.search.disabled = false;
    });

    els.search.addEventListener('click', onSearch);
    els.clear.addEventListener('click', onClear);
  }

  // ── Search ─────────────────────────────────────────────────
  function onSearch() {
    const make = els.make.value;
    const model = els.model.value;
    const year = els.year.value;
    const engine = els.engine.value;
    const collectionHandle = CONFIG.collectionHandle || 'all';

    if (!make) {
      alert('Please select at least a make.');
      return;
    }

    let ids = [];

    if (make && !model) {
      // All models under this make
      Object.values(vehicleData.tree[make] || {}).forEach(modelData => {
        Object.values(modelData.metaobject_ids || {}).forEach(id => ids.push(id));
      });

    } else if (make && model && !year) {
      // All years under this make/model
      Object.values(vehicleData.tree[make]?.[model]?.metaobject_ids || {}).forEach(id => ids.push(id));

    } else if (make && model && year && !engine) {
      // All engines under this make/model/year
      const allIds = vehicleData.tree[make]?.[model]?.metaobject_ids || {};
      Object.entries(allIds).forEach(([key, id]) => {
        if (key.startsWith(`${year}|`)) ids.push(id);
      });

    } else {
      // Exact match
      const key = `${year}|${engine}`;
      const id = vehicleData.tree[make]?.[model]?.metaobject_ids?.[key];
      if (id) ids.push(id);
    }

    if (ids.length === 0) {
      alert('No vehicles found for your selection.');
      return;
    }

    // Save to localStorage
    selectedVehicle = { make, model, year, engine };
    localStorage.setItem('fitment_vehicle', JSON.stringify(selectedVehicle));
    showSavedVehicle();

    // Build URL with multiple filter values
    const params = ids
      .map(id => `filter.p.m.fitment.vehicles=${encodeURIComponent(id)}`)
      .join('&');

    window.location.href = `/collections/${collectionHandle}?${params}`;
  }

  // ── Saved vehicle ──────────────────────────────────────────
  function showSavedVehicle() {
    if (!selectedVehicle) return;
    const { make, model, year, engine } = selectedVehicle;
    const label = [year, make, model, engine].filter(Boolean).join(' ');
    els.savedLabel.textContent = `Showing parts for: ${label}`;
    els.saved.style.display = 'block';
    els.clear.style.display = 'inline-block';
  }

  function restoreSelection() {
    if (!selectedVehicle.make) return;
    populateModels(selectedVehicle.make);
    els.make.value = selectedVehicle.make;

    if (selectedVehicle.model) {
      populateYears(selectedVehicle.make, selectedVehicle.model);
      els.model.value = selectedVehicle.model;
    }

    if (selectedVehicle.year) {
      populateEngines(selectedVehicle.make, selectedVehicle.model, selectedVehicle.year);
      els.year.value = selectedVehicle.year;
    }

    if (selectedVehicle.engine) {
      els.engine.value = selectedVehicle.engine;
    }

    els.search.disabled = false;
  }

  function onClear() {
    localStorage.removeItem('fitment_vehicle');
    selectedVehicle = null;
    els.saved.style.display = 'none';
    els.clear.style.display = 'none';
    resetSelect(els.make, 'Select Make');
    resetSelect(els.model, 'Select Model');
    resetSelect(els.year, 'Select Year');
    resetSelect(els.engine, 'Select Engine');
    populateMakes();
    els.model.disabled = true;
    els.year.disabled = true;
    els.engine.disabled = true;
    els.search.disabled = true;

    window.location.href = `/collections/${CONFIG.collectionHandle || 'all'}`;
  }

  // ── Helpers ────────────────────────────────────────────────
  function resetSelect(el, placeholder) {
    el.innerHTML = `<option value="">${placeholder}</option>`;
  }

  document.addEventListener('DOMContentLoaded', init);
})();